#import "../fragments/role-fragment.graphql"

mutation UpdateRolePermission($input: RoleUpdatePermissionInput!) {
    roleUpdatePermission(input: $input) {
        role {
            ...RoleFragment
        }
    }
}
